import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

// BonBoZ: hội thoại vừa được đánh dấu chưa đọc vẫn đang mở, mà MessagesView gọi
// `markMessagesRead` lại mỗi lần cuộn hoặc có tin mới. Không chặn thì server đọc
// lại ngay và dấu vừa đặt biến mất. Chặn tới khi người dùng rời sang hội thoại
// khác — `setActiveChat` gọi `allowAutoRead` để thả ra.
const autoReadBlocked = new Set();

// Việc commit "đã đọc" bị hoãn 4 giây (xem bên dưới). Giữ id để còn huỷ, nếu
// không cái hẹn cũ bắn sau và xoá dấu vừa đặt — đây là chỗ "lúc được lúc không".
const pendingReadCommits = new Map();

const cancelPendingRead = id => {
  clearTimeout(pendingReadCommits.get(id));
  pendingReadCommits.delete(id);
};

export const allowAutoRead = id => autoReadBlocked.delete(id);

export default {
  markMessagesRead: async ({ commit }, data) => {
    if (autoReadBlocked.has(data.id)) return;
    try {
      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);
      cancelPendingRead(id);
      pendingReadCommits.set(
        id,
        setTimeout(() => {
          pendingReadCommits.delete(id);
          commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
            id,
            lastSeen,
            unseenSince: 0,
          });
        }, 4000)
      );
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit, dispatch, state }, { id }) => {
    cancelPendingRead(id);
    autoReadBlocked.add(id);

    // Đặt dấu trước rồi mới gọi API: thẻ đỏ lên và nhảy lên đầu ngay khi bấm,
    // thay vì chờ hết một vòng mạng. Giá trị dưới đây là ước lượng — phản hồi
    // của server ghi đè lại ngay sau đó.
    const chat = state.allConversations.find(c => c.id === id);
    commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
      id,
      lastSeen: chat?.agent_last_seen_at,
      unreadCount: Math.max(chat?.unread_count || 0, 1),
      unseenSince: Math.floor(Date.now() / 1000),
    });

    try {
      const {
        data: {
          agent_last_seen_at: lastSeen,
          unread_count: unreadCount,
          unseen_since: unseenSince,
        },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
        unseenSince,
      });
      // Badge tab Hội thoại đọc từ một endpoint khác. Gọi thẳng thay vì đợi
      // broadcast, để con số trên tab đổi cùng lúc với thẻ.
      dispatch('conversationUnreadCounts/get', {}, { root: true });
    } catch (error) {
      autoReadBlocked.delete(id);
      throwErrorMessage(error);
    }
  },
};
